<template>
  <form
    class="pure-form"
    v-on:submit.prevent="onSubmit"
    @focus="getTags"
  >
    <fieldset>
        <input
          list="shelf-tags"
          v-model.trim="shelflabel"
          placeholder="Add a shelf"
          @focus="getTags"
        />
        <datalist id="shelf-tags">
          <option v-for="tag in tags" :values="tag.label">{{
            tag.label
          }}</option>
        </datalist>
      <button class="pure-button">Add</button>
    </fieldset>
  </form>
</template>

<script>
import axios from "axios";
import Vue from "vue";
export default {
  name: "add-shelf-form",
  data() {
    return {
      user: {},
      token: this.$cookies.get("user"),
      tags: [],
      shelflabel: ""
    };
  },
  methods: {
    getTags() {
      axios.get(`/tags`).then(response => (this.tags = response.data.data));
    },
    onSubmit() {
      axios
        .put(
          `/shelves`,
          {
            tag: this.shelflabel
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then(() => this.getShelves());
    }
  }
};
</script>
